import { generateHTML } from "@tiptap/html";

import { SanitizedHTML } from "@av/components/atoms/SanitizedHTML";
import type { AvE2EProps } from "@av/components/types";
import { stripBoundaryEmptyParagraphs } from "../editor-content";
import { extensions } from "./extentions";

import type { EditorWireFormat } from "../Editor";

type Props = { doc: string; isDevelopment?: boolean; wireFormat?: EditorWireFormat } & AvE2EProps;

export function RenderDocAsHTML({
  doc,
  isDevelopment,
  testIdPrefix,
  wireFormat = "tiptapJson",
}: Props) {
  const tiptapToHtml = (value?: string) => {
    if (wireFormat === "html") return stripBoundaryEmptyParagraphs(value ?? "");

    if (!value) return "";
    let parsed = null;

    try {
      parsed = JSON.parse(value);
    } catch (e) {
      if (isDevelopment) {
        console.error("Parsing rich text document failed", { e, value });
      }

      return `<p>${value}</p>`;
    }

    const doc = Array.isArray(parsed) ? { type: "doc", content: parsed } : parsed;

    return generateHTML(doc, extensions);
  };

  return (
    <SanitizedHTML
      testIdPrefix={`${testIdPrefix}-rich-text-editor`}
      htmlString={tiptapToHtml(doc)}
      allowTextFormattingStyles={wireFormat === "html"}
      openLinksInNewTab
    />
  );
}
